document.addEventListener('DOMContentLoaded', function() {
  // --- STATE ---
  let bundle = {}; // variantId -> { variantId, productId, title, price, comparePrice, image, qty }

  // Load state from localStorage on init
  try {
    const saved = localStorage.getItem('cosmix_bundle_builder_state');
    if (saved) {
      bundle = JSON.parse(saved);
    }
  } catch (e) {
    console.error('Failed to load bundle state from localStorage:', e);
  }

  // --- SETTINGS (with default fallbacks & theme customizer sync) ---
  const getSettings = () => {
    const defaults = {
      discountsEnabled: true,
      discountCode: 'BUNDLE_DISCOUNT',
      minCheckoutQty: 5,
      tiers: [
        { threshold: 3, discountPct: 50, qtyLimit: 1, label: 'Add 3', sublabel: '1 Product(s) @\n50% off' },
        { threshold: 6, discountPct: 75, qtyLimit: 2, label: 'Add 6', sublabel: '2 Product(s) @\n75% off' },
        { threshold: 9, discountPct: 100, qtyLimit: 2, label: 'Add 9', sublabel: '2 Product(s) @\n100% off' }
      ]
    };
    const s = window.BundleSettings || defaults;
    if (s.tiers && typeof s.tiers.sort === 'function') {
      s.tiers.sort((a, b) => a.threshold - b.threshold);
    }
    return s;
  };

  const settings = {
    get discountsEnabled() { return getSettings().discountsEnabled; },
    get discountCode() { return getSettings().discountCode; },
    get minCheckoutQty() { return parseInt(getSettings().minCheckoutQty) || 5; },
    get tiers() { return getSettings().tiers; }
  };

  // --- ELEMENTS ---
  const tabButtons = document.querySelectorAll('.bundle-tab-btn');
  const grids = document.querySelectorAll('.bundle-products-grid');
  
  // Desktop Elements
  const desktopItemsList = document.querySelector('.bundle-sidebar .bundle-items-list');
  const desktopItemsCount = document.querySelector('.bundle-sidebar .bundle-items-count');
  const desktopProgressMsg = document.querySelector('.bundle-sidebar .bundle-progress-message');
  const desktopTimelineFill = document.querySelector('.bundle-sidebar .bundle-timeline-fill');
  const desktopStepNodes = document.querySelectorAll('.bundle-sidebar .bundle-step-node');
  const desktopTotalPrice = document.querySelector('.bundle-sidebar .bundle-total-final');
  const desktopOriginalPrice = document.querySelector('.bundle-sidebar .bundle-total-original');
  const desktopCheckoutBtn = document.querySelector('.bundle-sidebar .bundle-checkout-btn');

  // Mobile Drawer Elements
  const mobileFooterBar = document.querySelector('.bundle-mobile-footer-bar');
  const mobileFooterQty = document.querySelector('.bundle-mobile-qty-count');
  const mobileFooterPrice = document.querySelector('.bundle-mobile-total-price');
  const mobileFooterOriginal = document.querySelector('.bundle-mobile-total-original');
  const mobileViewBtn = document.querySelector('.bundle-mobile-view-btn');

  const drawerOverlay = document.querySelector('.bundle-drawer-overlay');
  const drawerSheet = document.querySelector('.bundle-drawer-sheet');
  const drawerCloseBtn = document.querySelector('.bundle-drawer-close');
  const drawerItemsList = document.querySelector('.bundle-drawer-sheet .bundle-items-list');
  const drawerItemsCount = document.querySelector('.bundle-drawer-sheet .bundle-items-count');
  const drawerProgressMsg = document.querySelector('.bundle-drawer-sheet .bundle-progress-message');
  const drawerTimelineFill = document.querySelector('.bundle-drawer-sheet .bundle-timeline-fill');
  const drawerStepNodes = document.querySelectorAll('.bundle-drawer-sheet .bundle-step-node');
  const drawerTotalPrice = document.querySelector('.bundle-drawer-sheet .bundle-total-final');
  const drawerOriginalPrice = document.querySelector('.bundle-drawer-sheet .bundle-total-original');
  const drawerCheckoutBtn = document.querySelector('.bundle-drawer-sheet .bundle-checkout-btn');

  // --- TAB TOGGLE LOGIC ---
  tabButtons.forEach(button => {
    button.addEventListener('click', function() {
      const tabId = this.getAttribute('data-tab');
      
      tabButtons.forEach(btn => btn.classList.remove('active'));
      grids.forEach(grid => grid.classList.remove('active'));

      this.classList.add('active');
      const activeGrid = document.getElementById(tabId);
      if (activeGrid) {
        activeGrid.classList.add('active');
      }
    });
  });

  // --- MOBILE DRAWER TOGGLE ---
  if (mobileViewBtn) {
    mobileViewBtn.addEventListener('click', openDrawer);
  }
  if (drawerCloseBtn) {
    drawerCloseBtn.addEventListener('click', closeDrawer);
  }
  if (drawerOverlay) {
    drawerOverlay.addEventListener('click', closeDrawer);
  }

  function openDrawer() {
    drawerOverlay.classList.add('active');
    document.body.style.overflow = 'hidden'; // Stop background scrolling
  }

  function closeDrawer() {
    drawerOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  // --- QUANTITY EVENT DELEGATION ---
  document.addEventListener('click', function(e) {
    // Add to bundle button click
    if (e.target.classList.contains('bundle-add-btn')) {
      const card = e.target.closest('.bundle-product-card');
      const variantId = card.getAttribute('data-variant-id');
      const productId = card.getAttribute('data-product-id');
      const title = card.getAttribute('data-title');
      const price = parseFloat(card.getAttribute('data-price'));
      const comparePrice = parseFloat(card.getAttribute('data-compare-price')) || price;
      const image = card.getAttribute('data-image');

      addToBundle(variantId, productId, title, price, comparePrice, image);
    }

    // Plus button click
    if (e.target.classList.contains('js-qty-plus')) {
      const variantId = e.target.getAttribute('data-variant-id');
      updateQty(variantId, 1);
    }

    // Minus button click
    if (e.target.classList.contains('js-qty-minus')) {
      const variantId = e.target.getAttribute('data-variant-id');
      updateQty(variantId, -1);
    }

    // Remove row button click (trash icon)
    const removeBtn = e.target.closest('.bundle-item-remove');
    if (removeBtn) {
      const variantId = removeBtn.getAttribute('data-variant-id');
      removeFromBundle(variantId);
    }
  });

  // --- BUNDLE STATE MODIFICATION ---
  function addToBundle(variantId, productId, title, price, comparePrice, image) {
    if (!bundle[variantId]) {
      bundle[variantId] = {
        variantId,
        productId,
        title,
        price,
        comparePrice,
        image,
        qty: 0
      };
    }
    bundle[variantId].qty += 1;
    updateCardUI(variantId, bundle[variantId].qty);
    calculateAndRender();
  }

  function updateQty(variantId, change) {
    if (!bundle[variantId]) return;
    
    bundle[variantId].qty += change;
    
    if (bundle[variantId].qty <= 0) {
      delete bundle[variantId];
      updateCardUI(variantId, 0);
    } else {
      updateCardUI(variantId, bundle[variantId].qty);
    }
    calculateAndRender();
  }

  function removeFromBundle(variantId) {
    if (bundle[variantId]) {
      delete bundle[variantId];
      updateCardUI(variantId, 0);
      calculateAndRender();
    }
  }

  // Sync Card Button/Quantity display
  function updateCardUI(variantId, qty) {
    const cards = document.querySelectorAll(`.bundle-product-card[data-variant-id="${variantId}"]`);
    cards.forEach(card => {
      const actionsWrapper = card.querySelector('.bundle-card-actions');
      if (!actionsWrapper) return;

      if (qty > 0) {
        card.classList.add('in-bundle');
        actionsWrapper.innerHTML = `
          <div class="bundle-qty-selector">
            <button class="bundle-qty-btn js-qty-minus" data-variant-id="${variantId}" aria-label="Decrease">&minus;</button>
            <span class="bundle-qty-val">${qty}</span>
            <button class="bundle-qty-btn js-qty-plus" data-variant-id="${variantId}" aria-label="Increase">+</button>
          </div>
        `;
      } else {
        card.classList.remove('in-bundle');
        actionsWrapper.innerHTML = `
          <button class="bundle-add-btn" data-variant-id="${variantId}">+ ADD</button>
        `;
      }
    });
  }

  // --- CALCULATE TOTALS & DISCOUNTS ---
  function calculateAndRender() {
    let totalQty = 0;
    let originalTotalCents = 0;
    let discountedTotalCents = 0;

    // Create a flat array of all item units in the bundle for sorting and discount allocation
    let flatItems = [];
    
    Object.values(bundle).forEach(item => {
      totalQty += item.qty;
      originalTotalCents += item.price * item.qty;
      
      for (let i = 0; i < item.qty; i++) {
        flatItems.push({
          variantId: item.variantId,
          productId: item.productId,
          title: item.title,
          price: item.price,
          comparePrice: item.comparePrice,
          image: item.image,
          discountedPrice: item.price, // Default: no discount
          discountPct: 0,
          tierIndex: -1
        });
      }
    });

    // Determine highest active tier based on total quantity
    let activeTier = null;
    let activeTierIndex = -1;

    if (settings.discountsEnabled) {
      for (let i = settings.tiers.length - 1; i >= 0; i--) {
        if (totalQty >= settings.tiers[i].threshold) {
          activeTier = settings.tiers[i];
          activeTierIndex = i;
          break;
        }
      }
    }

    // Apply tier discounts to the cheapest items in the bundle
    if (activeTier) {
      // Sort flat units by price ascending (cheapest gets discounted first)
      flatItems.sort((a, b) => a.price - b.price);

      // Apply discount to the limit number of items allowed by the tier
      const limit = Math.min(activeTier.qtyLimit, flatItems.length);
      for (let i = 0; i < limit; i++) {
        const discountVal = activeTier.discountPct / 100;
        flatItems[i].discountedPrice = flatItems[i].price * (1 - discountVal);
        flatItems[i].discountPct = activeTier.discountPct;
        flatItems[i].tierIndex = activeTierIndex;
      }
    }

    // Sum up totals from flat items
    flatItems.forEach(item => {
      discountedTotalCents += item.discountedPrice;
    });

    // Reconstruct list of bundle items for template rendering
    // Group back the flat items by variantId, compiling discount details
    let groupedItems = {};
    flatItems.forEach(item => {
      if (!groupedItems[item.variantId]) {
        groupedItems[item.variantId] = {
          variantId: item.variantId,
          title: item.title,
          image: item.image,
          qty: 0,
          totalOriginalPrice: 0,
          totalDiscountedPrice: 0,
          discounts: [] // list of discount percentages for units in this group
        };
      }
      groupedItems[item.variantId].qty += 1;
      groupedItems[item.variantId].totalOriginalPrice += item.price;
      groupedItems[item.variantId].totalDiscountedPrice += item.discountedPrice;
      if (item.discountPct > 0) {
        groupedItems[item.variantId].discounts.push(item.discountPct);
      }
    });

    renderSidebarAndDrawer(
      totalQty,
      originalTotalCents,
      discountedTotalCents,
      groupedItems,
      activeTier,
      activeTierIndex
    );

    saveBundleToStorage();
  }

  function saveBundleToStorage() {
    try {
      localStorage.setItem('cosmix_bundle_builder_state', JSON.stringify(bundle));
    } catch (e) {
      console.error('Failed to save bundle state to localStorage:', e);
    }
  }

  // --- RENDER SIDEBAR AND DRAWER UI ---
  function renderSidebarAndDrawer(totalQty, originalTotal, discountedTotal, groupedItems, activeTier, activeTierIndex) {
    // 1. Format Currency Helper
    const formatCurrency = (cents) => {
      const symbol = window.currency || '$';
      return symbol + (cents / 100).toFixed(2);
    };

    // 2. Generate Items HTML
    let itemsHtml = '';
    const itemsArray = Object.values(groupedItems);
    
    if (itemsArray.length === 0) {
      itemsHtml = `
        <div style="text-align: center; padding: 40px 0; color: var(--cosmix-gray-muted);">
          <svg style="width: 40px; height: 40px; margin-bottom: 12px; fill: #D0C9C0;" viewBox="0 0 24 24">
            <path d="M17.21 9l-4.38-6.56c-.18-.28-.5-.44-.83-.44-.33 0-.65.16-.83.44L6.79 9H2c-.55 0-1 .45-1 1v1c0 .24.09.47.24.65L3.48 21c.2.3.54.48.91.48h15.22c.38 0 .72-.18.91-.48l2.24-9.35c.15-.18.24-.41.24-.65v-1c0-.55-.45-1-1-1h-4.79zM9 9l3-4.5L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
          </svg>
          <p style="margin: 0; font-size: 13px; font-weight: 600;">Your bundle is empty.</p>
          <p style="margin: 4px 0 0 0; font-size: 11px;">Add products below to get started.</p>
        </div>
      `;
    } else {
      itemsArray.forEach(item => {
        const isRowDiscounted = item.totalDiscountedPrice < item.totalOriginalPrice;
        const highestDiscount = item.discounts.length > 0 ? Math.max(...item.discounts) : 0;
        
        itemsHtml += `
          <div class="bundle-item-row">
            <div class="bundle-item-thumb">
              <img src="${item.image}" alt="${item.title}">
              ${highestDiscount > 0 ? `<div class="bundle-item-badge">${highestDiscount}% OFF</div>` : ''}
            </div>
            <div class="bundle-item-details">
              <h4 class="bundle-item-name">${item.title}</h4>
              <div class="bundle-item-price-qty">
                <div class="bundle-item-price-wrapper">
                  ${isRowDiscounted 
                    ? `<span class="bundle-item-price discounted">${formatCurrency(item.totalDiscountedPrice)}</span>
                       <span class="bundle-item-original-price">${formatCurrency(item.totalOriginalPrice)}</span>`
                    : `<span class="bundle-item-price">${formatCurrency(item.totalOriginalPrice)}</span>`
                  }
                </div>
                <div class="bundle-item-qty-controls">
                  <button class="bundle-summary-qty-btn js-qty-minus" data-variant-id="${item.variantId}" aria-label="Decrease">&minus;</button>
                  <span class="bundle-summary-qty-val">${item.qty}</span>
                  <button class="bundle-summary-qty-btn js-qty-plus" data-variant-id="${item.variantId}" aria-label="Increase">+</button>
                </div>
              </div>
            </div>
            <button class="bundle-item-remove" data-variant-id="${item.variantId}" aria-label="Remove item">
              <svg viewBox="0 0 24 24"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
            </button>
          </div>
        `;
      });
    }

    // 3. Render items into containers
    if (desktopItemsList) desktopItemsList.innerHTML = itemsHtml;
    if (drawerItemsList) drawerItemsList.innerHTML = itemsHtml;

    // 4. Update Header Counts
    const countText = `${totalQty} item(s)`;
    if (desktopItemsCount) desktopItemsCount.textContent = countText;
    if (drawerItemsCount) drawerItemsCount.textContent = countText;

    // 5. Update Progress Messages & Timeline Visuals
    // Determine target/next tier
    let nextTier = null;
    let itemsNeeded = 0;
    
    if (settings.discountsEnabled) {
      for (let i = 0; i < settings.tiers.length; i++) {
        if (totalQty < settings.tiers[i].threshold) {
          nextTier = settings.tiers[i];
          itemsNeeded = nextTier.threshold - totalQty;
          break;
        }
      }
    }

    let progressMsgText = '';
    if (!settings.discountsEnabled) {
      progressMsgText = `Build your bundle of ${settings.minCheckoutQty}+ items!`;
    } else if (nextTier) {
      progressMsgText = `Add ${itemsNeeded} more to get ${nextTier.qtyLimit} product(s) at ${nextTier.discountPct}% off!`;
    } else {
      progressMsgText = `🎉 You've unlocked the maximum bundle discount!`;
    }

    if (desktopProgressMsg) desktopProgressMsg.textContent = progressMsgText;
    if (drawerProgressMsg) drawerProgressMsg.textContent = progressMsgText;

    // Timeline Line Filling
    // Segment logic (e.g. 0 to 3, 3 to 6, 6 to 9)
    let fillPct = 0;
    if (settings.discountsEnabled && settings.tiers.length > 0) {
      const maxThreshold = settings.tiers[settings.tiers.length - 1].threshold;
      
      if (totalQty >= maxThreshold) {
        fillPct = 100;
      } else {
        // Segment-based interpolation
        const segmentCount = settings.tiers.length;
        const segmentWidth = 100 / segmentCount;
        
        let currentSegmentIdx = 0;
        let segmentStart = 0;
        let segmentEnd = settings.tiers[0].threshold;

        for (let i = 0; i < settings.tiers.length; i++) {
          const t = settings.tiers[i].threshold;
          const prevT = i > 0 ? settings.tiers[i - 1].threshold : 0;
          if (totalQty >= prevT && totalQty < t) {
            currentSegmentIdx = i;
            segmentStart = prevT;
            segmentEnd = t;
            break;
          }
        }

        const segmentProgress = (totalQty - segmentStart) / (segmentEnd - segmentStart);
        fillPct = (currentSegmentIdx * segmentWidth) + (segmentProgress * segmentWidth);
      }
    }

    if (desktopTimelineFill) desktopTimelineFill.style.width = fillPct + '%';
    if (drawerTimelineFill) drawerTimelineFill.style.width = fillPct + '%';

    // Timeline Node Activation
    const updateNodes = (nodes) => {
      nodes.forEach((node, idx) => {
        const threshold = parseInt(node.getAttribute('data-threshold'));
        if (totalQty >= threshold) {
          node.classList.add('active');
        } else {
          node.classList.remove('active');
        }
      });
    };
    updateNodes(desktopStepNodes);
    updateNodes(drawerStepNodes);

    // 6. Update Price Summaries
    const isCartDiscounted = discountedTotal < originalTotal;
    const updatePrices = (finalContainer, originalContainer) => {
      if (finalContainer) {
        finalContainer.textContent = formatCurrency(discountedTotal);
        if (isCartDiscounted) {
          finalContainer.classList.add('discounted');
        } else {
          finalContainer.classList.remove('discounted');
        }
      }
      if (originalContainer) {
        if (isCartDiscounted) {
          originalContainer.textContent = formatCurrency(originalTotal);
          originalContainer.style.display = 'inline-block';
        } else {
          originalContainer.textContent = '';
          originalContainer.style.display = 'none';
        }
      }
    };
    updatePrices(desktopTotalPrice, desktopOriginalPrice);
    updatePrices(drawerTotalPrice, drawerOriginalPrice);

    // 7. Update Checkout Button State & Validation
    const isCheckoutAllowed = totalQty >= settings.minCheckoutQty;
    
    const updateCheckoutBtn = (btn) => {
      if (!btn) return;
      if (isCheckoutAllowed) {
        btn.disabled = false;
        btn.innerHTML = `Add To Cart <svg style="width:16px;height:16px;fill:currentColor;" viewBox="0 0 24 24"><path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z"/></svg>`;
      } else {
        btn.disabled = true;
        const diff = settings.minCheckoutQty - totalQty;
        btn.textContent = `Add ${diff} more to checkout`;
      }
    };
    updateCheckoutBtn(desktopCheckoutBtn);
    updateCheckoutBtn(drawerCheckoutBtn);

    // 8. Mobile Footer Bar Sync
    if (mobileFooterBar) {
      if (totalQty > 0) {
        mobileFooterBar.style.display = 'flex';
        if (mobileFooterQty) {
          const minQty = settings.minCheckoutQty;
          if (totalQty >= minQty) {
            mobileFooterQty.textContent = `${totalQty} items selected`;
          } else {
            mobileFooterQty.textContent = `${totalQty} out of ${minQty} items selected`;
          }
        }
        if (mobileFooterPrice) {
          mobileFooterPrice.textContent = formatCurrency(discountedTotal);
        }
        if (mobileFooterOriginal) {
          if (isCartDiscounted) {
            mobileFooterOriginal.textContent = formatCurrency(originalTotal);
            mobileFooterOriginal.style.display = 'inline';
          } else {
            mobileFooterOriginal.textContent = '';
            mobileFooterOriginal.style.display = 'none';
          }
        }
      } else {
        mobileFooterBar.style.display = 'none';
      }
    }
  }

  // --- SUBMIT CART TO SHOPIFY API ---
  const checkoutButtons = [desktopCheckoutBtn, drawerCheckoutBtn];
  
  // Safe routing fallback for internationalization or older templates
  const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  
  checkoutButtons.forEach(btn => {
    if (!btn) return;
    btn.addEventListener('click', function() {
      // Create items array for Shopify cart API
      let itemsToAdd = [];
      Object.values(bundle).forEach(item => {
        itemsToAdd.push({
          id: parseInt(item.variantId),
          quantity: item.qty,
          properties: {
            "_bundle_builder": "true"
          }
        });
      });

      if (itemsToAdd.length === 0) return;

      // Update button visual state
      const originalText = this.innerHTML;
      checkoutButtons.forEach(b => {
        if (b) {
          b.disabled = true;
          b.textContent = 'Adding to Cart...';
        }
      });

      // Clear existing cart items first to avoid blending with old purchases
      fetch(rootPath + 'cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(() => {
        // Now add bundle items
        return fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        });
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        // Check if discount is active and we have a discount code
        let totalQty = 0;
        Object.values(bundle).forEach(item => totalQty += item.qty);
        
        let highestActiveTier = null;
        if (settings.discountsEnabled) {
          for (let i = settings.tiers.length - 1; i >= 0; i--) {
            if (totalQty >= settings.tiers[i].threshold) {
              highestActiveTier = settings.tiers[i];
              break;
            }
          }
        }

        if (highestActiveTier && settings.discountCode) {
          // Set discount cookie in background so it's applied when they checkout later
          return fetch(rootPath + 'discount/' + encodeURIComponent(settings.discountCode))
            .then(() => data)
            .catch(() => data);
        }
        return data;
      })
      .then(data => {
        // Trigger theme's default AJAX cart drawer update and opening
        if (window.updateMiniCart) {
          window.updateMiniCart(true);
        } else {
          const miniCart = document.getElementById('mini-cart');
          if (miniCart && typeof miniCart.open === 'function') {
            miniCart.open();
          } else {
            window.location.href = '/cart';
          }
        }

        // Close mobile sheet if open
        closeDrawer();

        // Clear bundle, delete localStorage cache, and reset card buttons back to '+ ADD'
        bundle = {};
        try {
          localStorage.removeItem('cosmix_bundle_builder_state');
        } catch (e) {
          console.error(e);
        }
        
        const cards = document.querySelectorAll('.bundle-product-card');
        cards.forEach(card => {
          const variantId = card.getAttribute('data-variant-id');
          updateCardUI(variantId, 0);
        });
        calculateAndRender();
      })
      .catch(error => {
        console.error('Error adding bundle to cart:', error);
        alert('There was a problem adding the bundle to your cart. Please try again.');
        // Re-enable buttons
        checkoutButtons.forEach((b, idx) => {
          if (b) {
            calculateAndRender(); // Trigger calculation and restore original state
          }
        });
      });
    });
  });

  // Helper to fully sync stored bundle UIs and recalculate totals
  function syncBundleState() {
    Object.keys(bundle).forEach(variantId => {
      updateCardUI(variantId, bundle[variantId].qty);
    });
    calculateAndRender();
  }

  // --- ROBUST PAGE LOAD & APP RACE CONDITION OVERRIDES ---
  // Run 1: Run immediately when DOMContentLoaded fires
  syncBundleState();

  // Run 2: Run when window load event fires (after all external resources, swatches, and currency apps are ready)
  window.addEventListener('load', function() {
    syncBundleState();
    // Run 3 & 4: Run at brief delays to overwrite any late DOM modifications from third-party apps
    setTimeout(syncBundleState, 400);
    setTimeout(syncBundleState, 1200);
  });

  // Shopify Theme Editor Section Reload Handler
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('.bundle-builder-section')) {
      syncBundleState();
    }
  });
});
